module.exports = __webpack_public_path__ + "static/media/headbanner2.da797501.mp4";